export default __webpack_public_path__ + "KaTeX_AMS-Regular.d4531cf7ff335a5e1d2c2caa803e2592.woff2";